import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { NgSelectConfig, NgSelectModule, ɵs } from "@ng-select/ng-select";
import { ButtonsModule, CardsModule, CheckboxModule, IconsModule, InputsModule, ModalModule, WavesModule } from "angular-bootstrap-md";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ProcessedReportComponent } from "./processed-report/processed-report.component";
import { ReportsMenuComponent } from "./reports-menu/reports-menu.component";
import { ReportsComponent } from "./reports.component";
import { DashboardReportsComponent } from './dashboard-reports/dashboard-reports.component';
import { RbmPopupComponent } from './rbm-popup/rbm-popup.component';
import { AbmPopupComponent } from './abm-popup/abm-popup.component';
import { RsPopupComponent } from './rs-popup/rs-popup.component';
import { RbmDashboardComponent } from './rbm-dashboard/rbm-dashboard.component';
import { AbmDashboardComponent } from './abm-dashboard/abm-dashboard.component';
import { SoDashboardComponent } from './so-dashboard/so-dashboard.component';
import { RsDashboardComponent } from './rs-dashboard/rs-dashboard.component';
import { DdPopupComponent } from './dd-popup/dd-popup.component';
import { RssoDashboardComponent } from './rsso-dashboard/rsso-dashboard.component';
import { DealerDashboardComponent } from './dealer-dashboard/dealer-dashboard.component';
import { IddPopupComponent } from './idd-popup/idd-popup.component';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { AuthGuard } from "../services/auth-guard.service";

export const dashboardRoutes: Routes = [
 // { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'Sales-performance',
    component: ReportsComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'order-tracking',
    component: ProcessedReportComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'dashboard-report',
    component: DashboardReportsComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'dashboard',
    component: ReportsDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'rbm-report',
    component: RbmDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'abm-report',
    component: AbmDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'so-report',
    component: SoDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'rs-report',
    component: RsDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'rsso-report',
    component: RssoDashboardComponent,
    canActivate:[AuthGuard]
  },
  {
    path: 'dealer-report',
    component: DealerDashboardComponent,
    canActivate:[AuthGuard]
  },
]

@NgModule({
  declarations: [ReportsComponent, ProcessedReportComponent, ReportsMenuComponent, DashboardReportsComponent, RbmPopupComponent, AbmPopupComponent, RsPopupComponent, RbmDashboardComponent, AbmDashboardComponent, SoDashboardComponent, RsDashboardComponent, DdPopupComponent, RssoDashboardComponent, DealerDashboardComponent, IddPopupComponent, ReportsDashboardComponent],
  imports: [ InfiniteScrollModule,NgSelectModule,
    CommonModule, RouterModule.forChild(dashboardRoutes), FormsModule, CheckboxModule, WavesModule, ButtonsModule, InputsModule, IconsModule, CardsModule, ModalModule, ReactiveFormsModule
  ],
  providers: [ NgSelectConfig, ɵs , AuthGuard]
})
export class ReportsModule { }
